<template>
  <div class="p-5">
    <div v-if="!msgUnificar">
      <vs-alert class="alertAssociadoBaseAntiga" color="danger">
        <div class="flex gap-3 pl-4">
          <vs-icon
            icon-pack="feather"
            icon="icon-alert-circle"
            size="small"
          ></vs-icon>
          <div>
            <h6 class="font-bold">Alerta</h6>
            <div>
              <h6>
                Encontramos beneficiário(s)
                <b class="font-bold">com o mesmo CPF</b>
                na base de dados.
              </h6>
            </div>
          </div>
        </div>
      </vs-alert>

      <div class="mt-5">
        <div class="my-3">
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-camera"
            class="d-inline"
            @click.stop.prevent="mostrarFoto()"
          >
            <h6 style="color: white">Ver Foto CNH da vistoria</h6></vs-button
          >
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vx-card>
              <h5 class="mb-4 text-center">Beneficiário Atual da Proposta</h5>
              <ul class="tracejado">
                <li>
                  <b>ID:</b>
                  {{ dadosProspect.idProspect }}
                  <router-link
                    target="_blank"
                    :to="`/DetalheAssociado/${dadosProspect.idProspect}`"
                  >
                    <feather-icon
                      icon="ExternalLinkIcon"
                      svgClasses="h-4 w-4"
                    />
                  </router-link>
                  <vs-chip
                    :color="getSituacaoVeiculoColor(dadosProspect.situacao)"
                    class="chipSituacaoVeiculo rounded ml-3"
                    >{{ dadosProspect.situacao }}
                  </vs-chip>
                </li>
                <li>
                  <b>Nome:</b>
                  {{ dadosProspect.associado }}
                </li>
                <li>
                  <b>CPF:</b>
                  {{ dadosProspect.cpf }}
                </li>
                <li>
                  <b>Email:</b>
                  {{ dadosProspect.email }}
                </li>
                <li>
                  <b>Celular:</b>
                  {{ dadosProspect.celular }}
                </li>
                <li>
                  <b>Endereço:</b>
                  {{ dadosProspect.endereco }}, {{ dadosProspect.numero }}
                  {{ dadosProspect.complemento }} <br />
                  {{ dadosProspect.bairro }} - {{ dadosProspect.cidade }} /
                  {{ dadosProspect.estado }} <br />
                  {{ dadosProspect.cep }}
                </li>
              </ul>
            </vx-card>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vx-card>
              <h5 class="mb-4 text-center">Novo Beneficiário da Proposta</h5>
              <ul>
                <li>
                  <b>ID:</b>
                  {{ dadosAssociadoUnificado.id_prospect }}
                  <router-link
                    target="_blank"
                    :to="`/DetalheAssociado/${dadosAssociadoUnificado.id_prospect}`"
                  >
                    <feather-icon
                      icon="ExternalLinkIcon"
                      svgClasses="h-4 w-4"
                    />
                  </router-link>
                  <vs-chip
                    :color="
                      getSituacaoVeiculoColor(dadosAssociadoUnificado.situacao)
                    "
                    class="chipSituacaoVeiculo rounded ml-3"
                    >{{ dadosAssociadoUnificado.situacao }}
                  </vs-chip>
                </li>
                <li>
                  <b>Nome:</b>
                  {{ dadosAssociadoUnificado.nome }}
                </li>
                <li>
                  <b>CPF:</b>
                  {{ dadosAssociadoUnificado.cpfcnpj }}
                </li>
                <li>
                  <b>Email:</b>
                  {{ dadosAssociadoUnificado.email }}
                </li>
                <li>
                  <b>Celular:</b>
                  {{ dadosAssociadoUnificado.celular }}
                </li>
                <li>
                  <b>Endereço:</b>
                  {{ dadosAssociadoUnificado.endereco }},
                  {{ dadosAssociadoUnificado.numero }}
                  {{ dadosAssociadoUnificado.complemento }} <br />
                  {{ dadosAssociadoUnificado.bairro }} -
                  {{ dadosAssociadoUnificado.cidade }} /
                  {{ dadosAssociadoUnificado.estado }} <br />
                  {{ dadosAssociadoUnificado.cep }}
                </li>
                <li>
                  <b>Consultor:</b>
                  {{ dadosAssociadoUnificado.consultor }}
                </li>
                <li>
                  <b>{{ $t('Regional') }}:</b>
                  {{ dadosAssociadoUnificado.regional }}
                </li>
                <li>
                  <b>Data de Criação:</b>
                  {{ dadosAssociadoUnificado.createdAt | formatDate }}
                </li>
                <li>
                  <b>Data de Ativação:</b>
                  {{ dadosAssociadoUnificado.dataAtivacao | formatDate }}
                </li>

                <li class="mt-3">
                  <p class="lg:w-1/5 font-semibold">Veículo(s):</p>

                  <ul>
                    <li
                      class="p-0 flex justify-between gap-2 mb-1"
                      v-for="veiculos in dadosAssociadoUnificado.veiculos"
                      :key="veiculos.id"
                    >
                      <p class="">
                        {{ veiculos.placa }}

                        {{ veiculos.veiculoMarca }}

                        {{ veiculos.veiculoModelo }}

                        <vs-chip
                          :color="getSituacaoVeiculoColor(veiculos.status)"
                          class="chipSituacaoVeiculo rounded"
                        >
                          {{ veiculos.status }}
                        </vs-chip>
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </vx-card>
          </div>
        </div>
      </div>

      <div class="mt-5 flex justify-between">
        <vs-button
          color="#FF1800"
          class="p-4"
          @click.stop.prevent="redirectAlterarProposta()"
        >
          <h6 style="color: white">Este CPF esta errado</h6></vs-button
        >
        <vs-button
          color="#158C12"
          class="p-4"
          @click.stop.prevent="msgUnificar = true"
        >
          <h6 style="color: white">Unificar, são a mesma pessoa!</h6></vs-button
        >
      </div>
    </div>
    <div v-else>
      <vs-alert class="alertAssociadoBaseAntiga" color="danger">
        <div class="flex gap-3 pl-4">
          <vs-icon
            icon-pack="feather"
            icon="icon-alert-circle"
            size="small"
          ></vs-icon>
          <div>
            <h6 class="font-bold">Muita Atenção</h6>
            <div>
              <h6>
                Ao dar continuidade na unificação, todos os dados dessa proposta
                serão direcionados para o Beneficiário já existente id
                {{ dadosAssociadoUnificado.id_prospect }}, nome:
                {{ dadosAssociadoUnificado.nome }}. <br />
                Os dados do Beneficiário atual dessa proposta podem se perder e
                essa operação pode ser irreversível.
              </h6>
            </div>
          </div>
        </div>
      </vs-alert>
      <vx-input-group class="mt-3">
        <vs-input v-model="textoUnificar" placeholder="Digite unificar" />
        <template slot="append">
          <vs-button
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-copy"
            class="d-inline"
            @click="unificar()"
            >UNIFICAR</vs-button
          >
        </template>
      </vx-input-group>
    </div>
  </div>
</template>

<script>
import VxCard from '../../components/vx-card/VxCard.vue';
import functions from '../../utils/functions';

export default {
  components: { VxCard },
  name: 'ModalAssociadoUnificado',

  props: ['dadosAssociadoUnificado', 'dadosProspect'],

  data() {
    return {
      veiculosAssociado117: [],
      modalAssociadoEmpresa117: false,
      acao: null,
      msgUnificar: false,
      textoUnificar: null,
    };
  },

  methods: {
    getSituacaoVeiculoColor(data) {
      if (data == 'ATIVO') return '#158C12';
      if (data == 'INADIMPLENTE') return '#FF1800';
      if (data == 'INATIVO') return 'dark';
      return 'danger';
    },
    unificar() {
      if (
        this.textoUnificar == 'unificar' ||
        this.textoUnificar == 'Unificar'
      ) {
        this.$emit('unificar');
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite "Unificar" na caixa de texto ',
          color: 'danger',
        });
      }
    },
    mostrarFoto() {
      this.$emit('mostraFoto');
    },
    redirectAlterarProposta() {
      const link = `/editarCotacao2/${this.$route.params.idCotacao}`;
      this.$router.push(link);
      this.$emit('closeModal');
    },
  },
  mounted() {
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
};
</script>
<style scoped>
.alertAssociadoBaseAntiga {
  height: auto !important;
  border-radius: 15px;
  padding: 10px 0;
}
.associados117 h6 {
  letter-spacing: 0;
  font-size: 12px;
}
.associados117 p {
  letter-spacing: 0;
  font-size: 12px;
}
.associados117 li {
  display: flex;
  padding: 10px;
  gap: 4px;
}
.associados117 ul > li:nth-of-type(odd) {
  background-color: #f1f1f1;
  border-radius: 5px;
}
.associados117 .vs-button {
  border-radius: 15px;
}
.chipSituacaoVeiculo.con-vs-chip {
  min-height: 0;
  float: none;
  display: inline-block;
}

.tracejado li {
  text-decoration: line-through;
}
</style>
<style>
.associados117 .vs-popup--header {
  background: none;
}
.buttonAlteracaoStatus .vs-button {
  border-radius: 50px !important;
  width: auto !important;
  height: auto !important;
}
.associados117.con-vs-popup .vs-popup {
  z-index: 99999 !important;
}
</style>
